import Ajax from '../ajax';

export default {
  get: (productId) => Ajax('get', `swapout/product/${productId}`),
  list: (data) => Ajax('get', 'swapout/product', data),
  add: (data) => Ajax('post', 'swapout/product', data),
  edit: (id, data) => Ajax('put', `swapout/product/${id}`, data),
  addPoint: (data) => Ajax('post', 'swapout/product/point', data),
  editPoint: (id, data) => Ajax('put', `swapout/product/point/${id}`, data),
  addDiscountCoupon: (data) => Ajax('post', 'swapout/product/discountCoupon', data),
  editDiscountCoupon: (id, data) => Ajax('put', `swapout/product/discountCoupon/${id}`, data),
  setTag: (productId, data) => Ajax('post', `swapout/product/tagedit?productId=${productId}`, data),
  setType: (productId, data) => Ajax('post', `swapout/product/categoryedit?productId=${productId}`, data),
  modifyStatus: (productId, isEnable) => Ajax('post', `swapout/product/enable/${productId}?isEnable=${isEnable}`),
};
